/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiBroadcastBroadcastStatisticsGet$Params {
  startDateInclusive?: string;
  endDateExclusive?: string;
  channelFilter?: string;
}

export function apiBroadcastBroadcastStatisticsGet(http: HttpClient, rootUrl: string, params?: ApiBroadcastBroadcastStatisticsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiBroadcastBroadcastStatisticsGet.PATH, 'get');
  if (params) {
    rb.query('startDateInclusive', params.startDateInclusive, {});
    rb.query('endDateExclusive', params.endDateExclusive, {});
    rb.query('channelFilter', params.channelFilter, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiBroadcastBroadcastStatisticsGet.PATH = '/api/Broadcast/broadcast-statistics';
